import { render } from "./NavigationTabToolbar.vue?vue&type=template&id=4dc93824&scoped=true&ts=true"
import script from "./NavigationTabToolbar.vue?vue&type=script&lang=ts"
export * from "./NavigationTabToolbar.vue?vue&type=script&lang=ts"

import "./NavigationTabToolbar.vue?vue&type=style&index=0&id=4dc93824&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dc93824"]])

export default __exports__